var DocumentChooser = /** @class */ (function () {
    function DocumentChooser(html, idPattern) {
        this.html = html;
        this.idPattern = idPattern;
    }
    DocumentChooser.prototype.render = function (placeholder, name, id, initialState) {
        var html = this.html.replace(/__NAME__/g, name).replace(/__ID__/g, id);
        // eslint-disable-next-line no-param-reassign
        placeholder.outerHTML = html;
        /* the chooser object returned by createDocumentChooser also serves as the JS widget representation */
        // eslint-disable-next-line no-undef
        var chooser = createDocumentChooser(id);
        chooser.setState(initialState);
        return chooser;
    };
    return DocumentChooser;
}());
window.telepath.register('wagtail.documents.widgets.DocumentChooser', DocumentChooser);
